module.exports = __webpack_public_path__ + "static/media/reportasje.c2a872af.mp3";